export default "__VITE_ASSET__1ee1ed4d__"